var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUstakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D18640"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_352_462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_352_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1435 51.65C40.7145 51.65 41.2117 51.4383 41.635 51.015C42.058 50.592 42.2695 50.089 42.2695 49.506C42.2695 48.9227 42.058 48.4255 41.635 48.0145C41.2117 47.6035 40.7099 47.398 40.1295 47.398C39.5489 47.398 39.0517 47.6027 38.638 48.012C38.2244 48.4217 38.0175 48.9243 38.0175 49.52C38.0175 50.0937 38.2255 50.592 38.6415 51.015C39.0579 51.4383 39.5585 51.65 40.1435 51.65ZM38.1675 44.35H41.5415C41.5415 43.521 41.6499 42.7482 41.8665 42.0315C42.0832 41.3148 42.7299 40.5087 43.8065 39.613C44.8022 38.8217 45.512 37.998 45.936 37.142C46.3597 36.2857 46.5715 35.3415 46.5715 34.3095C46.5715 32.4888 46.0127 31.031 44.895 29.936C43.777 28.841 42.2642 28.2935 40.3565 28.2935C38.6665 28.2935 37.1637 28.7395 35.848 29.6315C34.532 30.5235 33.5719 31.7253 32.9675 33.237L36.0695 34.402C36.4552 33.45 37.0004 32.7203 37.705 32.213C38.41 31.7057 39.2062 31.452 40.0935 31.452C41.0479 31.452 41.8397 31.7242 42.469 32.2685C43.0984 32.8125 43.413 33.5244 43.413 34.404C43.413 35.068 43.2105 35.7155 42.8055 36.3465C42.4005 36.9778 41.8284 37.5963 41.089 38.202C40.1267 39.031 39.3992 39.8995 38.9065 40.8075C38.4139 41.7152 38.1675 42.896 38.1675 44.35ZM40.004 60.7065C37.155 60.7065 34.4715 60.1667 31.9535 59.087C29.4359 58.007 27.2364 56.5263 25.355 54.645C23.4737 52.7637 21.993 50.5655 20.913 48.0505C19.8334 45.5352 19.2935 42.853 19.2935 40.004C19.2935 37.1217 19.8334 34.4215 20.913 31.9035C21.993 29.3858 23.4722 27.1942 25.3505 25.3285C27.2289 23.4628 29.4264 21.9858 31.943 20.8975C34.4597 19.8092 37.1432 19.265 39.9935 19.265C42.8775 19.265 45.5795 19.8085 48.0995 20.8955C50.6199 21.9822 52.812 23.4572 54.676 25.3205C56.5404 27.1835 58.0162 29.3743 59.1035 31.893C60.1912 34.4117 60.735 37.114 60.735 40C60.735 42.8517 60.1909 45.5362 59.1025 48.0535C58.0142 50.5712 56.5372 52.7695 54.6715 54.6485C52.8059 56.5275 50.6155 58.007 48.1005 59.087C45.5852 60.1667 42.8864 60.7065 40.004 60.7065ZM40 56.7455C44.658 56.7455 48.6135 55.1167 51.8665 51.859C55.1192 48.6013 56.7455 44.6483 56.7455 40C56.7455 35.342 55.1192 31.3865 51.8665 28.1335C48.6135 24.8808 44.6534 23.2545 39.986 23.2545C35.352 23.2545 31.4049 24.8808 28.1445 28.1335C24.8845 31.3865 23.2545 35.3467 23.2545 40.014C23.2545 44.648 24.8834 48.5952 28.141 51.8555C31.3987 55.1155 35.3517 56.7455 40 56.7455Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUstakeIcon);
export default __webpack_public_path__ + "static/media/ustake-icon.6d0a084bbdd0b6c4d390175c2a9e223f.svg";
export { ForwardRef as ReactComponent };